import { profileActions } from './ProfileAction';

const initState = {
    loadingFlags: {
        "attachment-status": true,
        "user": true,
        "upload-user-picture": false,
    },
    error: null,
    uploadPictureError: null,
    cancelTokens: {}
}

export default function profilePageReducer(state=initState, action) {
    switch (action.type) {
        case profileActions.setUploadDocumentCancelToken:
            return setUploadDocumentCancelToken(state, action);
        case profileActions.setError:
            return setError(state, action);
        case profileActions.toggleSpinner:
            return toggleSpinner(state, action);
        default:
            return state;
    }
}

function setUploadDocumentCancelToken(state, {payload}) {
    return {
        ...state,
        cancelTokens: {
            [payload.id]: payload.cancelTokenSource,
        },
    }
}

function setError(state, {payload, meta}) {
    if (meta && meta.apiName === 'upload-user-picture') {
        return {
            ...state,
            uploadPictureError: payload,
        }    
    }
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.showSpinner,
            [meta.apiName]: payload
        },
    }
}